import { IconButton, Stack, Typography } from '@mui/material'
import ExamDetailsList from './ExamDetailsList'
import ExamReason from './ExamReason'
import { QcTaskState, QcTimepointContainerSubmission } from '@common/config/api/client'
import { Fragment } from 'react/jsx-runtime'
import CommentModal from '../modals/CommentModal'
import { SPACING } from '@common/theme/spacing'

export function buildSiteCommentArray(container: QcTimepointContainerSubmission): string[] {
  const commentArray: string[] = []
  if (!container.no_file_submission_reason && container.comments?.trim()) {
    commentArray.push(container.comments.trim())
  }
  if (container.additional_comments?.trim()) {
    commentArray.push(container.additional_comments.trim())
  }
  return commentArray
}

export default function Exam({
  qcTaskOrder,
  qcTaskStatus,
  timepointSubmissionId,
  container,
}: {
  qcTaskOrder: number
  qcTaskStatus: QcTaskState
  timepointSubmissionId: string
  container: QcTimepointContainerSubmission
}) {
  const commentArray = buildSiteCommentArray(container)
  return (
    <Stack spacing={SPACING.formFieldsSpacing}>
      <Stack spacing={SPACING.minSpacing}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
            {container.container_requirement_name}
          </Typography>
          <IconButton>
            <CommentModal
              comment={commentArray}
              authorName={container.comment_author_name}
              requirementName={container.container_requirement_name}
            />
          </IconButton>
        </Stack>
        {container.no_file_submission_reason ? (
          <Fragment>
            <ExamReason reason={container.no_file_submission_reason} comment={container.comments} />
          </Fragment>
        ) : (
          <Fragment>
            <ExamDetailsList
              qcTaskOrder={qcTaskOrder}
              qcTaskStatus={qcTaskStatus}
              timepointSubmissionId={timepointSubmissionId}
              container={container}
            />
          </Fragment>
        )}
      </Stack>
    </Stack>
  )
}
